import { HttpContext, HttpContextToken, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { ApiGatewayError } from '../models/errors';
import { HttpErrors } from './http-errors';

export class RestUtils {
  static _role = 'guest';
  static readonly INSERT_XSRF = new HttpContextToken<boolean>(() => true);

  buildUrl(url: string, queryParams: object = {}, includeRole = true): string {
    let role = '';
    if (includeRole) {
      role = RestUtils.getRole();
    }
    if (!url.includes('https://') && !url.includes('http://')) {
      url = 'API_BASE_URL' + (url.charAt(0) === '/' ? '' : '/') + url;
    }
    url = url.replace('ROLE/', role ? role + '/' : '').replace('ROLE', role);

    const isValidQueryParam = (value: unknown) => value !== null && value !== undefined;

    const query: string[] = [];
    const params = queryParams as Record<string, unknown>;
    for (const key in params) {
      const value = params[key];

      if (Array.isArray(value)) {
        value.forEach(item => {
          if (isValidQueryParam(item)) {
            query.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`);
          }
        });
      } else if (isValidQueryParam(value)) {
        query.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
      }
    }

    if (query.length) {
      url += '?' + query.join('&');
    }
    return url;
  }

  handleError(error: HttpErrorResponse) {
    let apiGatewayError: ApiGatewayError;
    if (error.status !== 0 && error.error && error.error.message) {
      apiGatewayError = error.error;
    } else if (error.status !== 0 && typeof error.error === 'string') {
      apiGatewayError = {
        timestamp: null,
        path: null,
        status: error.status,
        error: error.error,
        message: error.error,
        requestId: null,
      };
    }

    let status = error.status;
    if (apiGatewayError && apiGatewayError.message === 'Invalid token') {
      status = 401;
    }

    HttpErrors.status.next(status);

    return throwError(() =>
      apiGatewayError
        ? {
            status: apiGatewayError.status,
            statusText: apiGatewayError.message,
            requestId: apiGatewayError.requestId,
            timestamp: apiGatewayError.timestamp,
            path: apiGatewayError.path,
            errorText: apiGatewayError.error,
          }
        : error
    );
  }

  getHttpHeaderOptions(headers: HttpHeaders, insertXsrf = true) {
    headers = headers instanceof HttpHeaders ? headers : new HttpHeaders();
    return {
      headers: headers,
      context: new HttpContext().set(RestUtils.INSERT_XSRF, insertXsrf),
      withCredentials: true,
    };
  }

  static getRole() {
    return RestUtils._role;
  }
}
